import React from "react";
import CommonHeader from "components/Headers/CommonHeader";
import { Container } from "reactstrap";

const PrivacyPolicy = () => {
  return (
    <>
      <CommonHeader />
      <Container className="mt-4 mb-5">
        <h1 className="mb-4">CradleAI Privacy Policy</h1>
        <p><strong>Effective Date:</strong> 30/Sep/2025</p>
        <p><strong>Last Updated:</strong> 06/OCT/2025</p>

        <p>
          Welcome to <strong>CradleAI</strong>, owned and operated by{" "}
          <strong>CradleAI</strong> (“we”, “our”, or “us”).
          We respect your privacy and are committed to protecting your personal information.
          This Privacy Policy explains how we collect, use, and safeguard your information when
          you use the CradleAI mobile application (the “App”) and related services.
        </p>
        <p>
          By using CradleAI, you agree to the practices described in this Privacy Policy.
        </p>

        <h3>1. Information We Collect</h3>
        <p>
          We collect the following types of information to help you use CradleAI safely and effectively:
        </p>

        <h5>1.1 Information You Provide</h5>
        <ul>
          <li>Name, age, gender, and photos</li>
          <li>Contact information (email, phone number, or login credentials via Apple/Google ID)</li>
          <li>Profile prompts, descriptions, interests, and lifestyle preferences</li>
          <li>Audio or video introductions (optional)</li>
          <li>
            Payment or card verification information (processed securely via third-party
            providers like Stripe)
          </li>
          <li>Any messages, voice notes, or videos exchanged with other users</li>
        </ul>

        <h5>1.2 Automatically Collected Information</h5>
        <ul>
          <li>Device information (model, OS, unique device IDs)</li>
          <li>Location data (if permission granted)</li>
          <li>Log data such as IP address, browser type, and in-app activity</li>
          <li>Usage statistics for analytics and performance</li>
        </ul>

        <h5>1.3 Information from Third Parties</h5>
        <p>
          If you sign up through Google, Apple, or Facebook, we receive limited information
          from those platforms as allowed by your settings (e.g., name, profile picture, email).
        </p>

        <h3>2. How We Use Your Information</h3>
        <ul>
          <li>Create and manage your CradleAI account</li>
          <li>Match you with compatible users</li>
          <li>Personalize your experience and show potential matches</li>
          <li>Facilitate communication (chats, voice/video calls)</li>
          <li>Process payments for verification or subscriptions</li>
          <li>Improve app performance and user experience</li>
          <li>Detect and prevent spam, fraud, or illegal activity</li>
          <li>Comply with applicable laws and regulations</li>
        </ul>
        <p><strong>We never sell your personal data to third parties.</strong></p>

        <h3>3. Card Verification and Payments</h3>
        <ul>
          <li>To keep CradleAI safe, we require a $1 card verification.</li>
          <li>Payments are processed securely via PCI-compliant payment providers (e.g., Stripe).</li>
          <li>We do not store your card details on our servers.</li>
          <li>
            You can remove your card from your account at any time after verification.
          </li>
        </ul>

        <h3>4. How We Share Your Information</h3>
        <p>We only share data with trusted third parties necessary to provide our services:</p>
        <ul>
          <li>Payment processors (for card verification and subscriptions)</li>
          <li>Analytics services (to improve performance)</li>
          <li>Cloud hosting partners (for secure data storage)</li>
          <li>Law enforcement, only when legally required</li>
        </ul>
        <p>
          All partners must comply with strict data protection and confidentiality obligations.
        </p>

        <h3>5. Data Security</h3>
        <p>
          We use administrative, technical, and physical safeguards to protect your personal
          data from unauthorized access, loss, misuse, or disclosure. However, no online service
          is 100% secure. By using CradleAI, you acknowledge that you share information at your own risk.
        </p>

        <h3>6. Data Retention</h3>
        <p>
          We retain your personal data only as long as necessary for the purposes described
          in this policy or as required by law. You may delete your account at any time, and
          we will permanently remove your data within a reasonable period.
        </p>

        <h3>7. Your Privacy Rights</h3>
        <p>
          Depending on your location, you may have rights to:
        </p>
        <ul>
          <li>Access or request a copy of your personal data</li>
          <li>Correct inaccurate or outdated information</li>
          <li>Delete your account and associated data</li>
          <li>Withdraw consent for data processing (where applicable)</li>
        </ul>
        <p>
          To exercise these rights, please contact us at{" "}
          <strong>Datecetra@gmail.com</strong>.
        </p>

        <h3>8. Cookies and Tracking</h3>
        <p>
          CradleAI uses cookies and similar technologies for:
        </p>
        <ul>
          <li>Improving app performance</li>
          <li>Analytics and crash reporting</li>
          <li>Remembering user preferences</li>
        </ul>
        <p>You can manage or disable cookies through your device settings.</p>

        <h3>9. Children’s Privacy</h3>
        <p>
          CradleAI is intended for users 18 years and older. We do not knowingly collect
          personal data from minors. If we become aware that data from a child under 18 has
          been collected, we will delete it immediately.
        </p>

        <h3>10. International Data Transfers</h3>
        <p>
          Your information may be transferred and processed outside your country of residence,
          where data protection laws may differ. We ensure all transfers comply with applicable privacy regulations.
        </p>

        <h3>11. Updates to This Policy</h3>
        <p>
          We may update this Privacy Policy from time to time to reflect changes in our
          practices or legal requirements. The updated version will always be posted within
          the app and on our website with the revised “Effective Date.”
        </p>

        <h3>12. Contact Us</h3>
        <p>If you have any questions or concerns about this Privacy Policy or your data, please contact us:</p>
        <p>
          📧 <strong>Email:</strong> Datecetra@gmail.com
          <br />
          🏢 <strong>Address:</strong> D-160, First Floor, Phase-8, Industrial Area, Sector 72,
          Sahibzada Ajit Singh Nagar, Punjab 160062
        </p>
      </Container>
    </>
  );
};

export default PrivacyPolicy;
